/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NovitusDiscountMarkupDto } from './NovitusDiscountMarkupDto';
import {
    NovitusDiscountMarkupDtoFromJSON,
    NovitusDiscountMarkupDtoFromJSONTyped,
    NovitusDiscountMarkupDtoToJSON,
} from './NovitusDiscountMarkupDto';

/**
 * 
 * @export
 * @interface NovitusSummaryDto
 */
export interface NovitusSummaryDto {
    /**
     * Kontrolna wartość zawierająca wartość wszystkich pozycji
     * @type {string}
     * @memberof NovitusSummaryDto
     */
    total: string;
    /**
     * Wartość wpłat
     * @type {string}
     * @memberof NovitusSummaryDto
     */
    pay_in: string;
    /**
     * Wartość reszty w walucie lokalnej
     * @type {string}
     * @memberof NovitusSummaryDto
     */
    change?: string;
    /**
     * Szczegóły rabatu/narzutu
     * @type {NovitusDiscountMarkupDto}
     * @memberof NovitusSummaryDto
     */
    discount_markup?: NovitusDiscountMarkupDto;
}

/**
 * Check if a given object implements the NovitusSummaryDto interface.
 */
export function instanceOfNovitusSummaryDto(value: object): value is NovitusSummaryDto {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('pay_in' in value) || value['pay_in'] === undefined) return false;
    return true;
}

export function NovitusSummaryDtoFromJSON(json: any): NovitusSummaryDto {
    return NovitusSummaryDtoFromJSONTyped(json, false);
}

export function NovitusSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusSummaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'pay_in': json['pay_in'],
        'change': json['change'] == null ? undefined : json['change'],
        'discount_markup': json['discount_markup'] == null ? undefined : NovitusDiscountMarkupDtoFromJSON(json['discount_markup']),
    };
}

export function NovitusSummaryDtoToJSON(value?: NovitusSummaryDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total': value['total'],
        'pay_in': value['pay_in'],
        'change': value['change'],
        'discount_markup': NovitusDiscountMarkupDtoToJSON(value['discount_markup']),
    };
}

